"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _uigDeviceUtil = _interopRequireDefault(require("@sfly/uig-device-util"));

var _uigCdnLibraries = require("@sfly/uig-cdn-libraries");

var _util = _interopRequireDefault(require("./util"));

var _Constants = require("./constants/Constants");
/*
 The Omniture implementation on the 2017 PIP Page and CP:
 On the load of the page, js_sitecatalyst loads s_code.js and s_code_wrapper.js onto the page, with pre-populated
 environment variables that are injected by analytics services in app code. This process creates a window.scw object
 which then transfers its data to the window.s omniture tracking object which is the basis for interacting with
 omniture. By mutating the fields of this s object, and then calling the s object with a click - s.tl() event or load -
 s.t() event, data is sent to omniture. These methods here abstract away the mutation of the required variables/data and
 calls for specific tracking events determined by the omniture team at shutterfly and are called within the
 react components which make up the thumbnail page.
 v-gtsolov - 17/08/17, thanks to rhang

 Omniture DTL uses JSON-based reporting rather than event numbers and variable numbers. For standalone Javascript apps,
 there is a new servlet that delivers all of the information needed for reporting along with most of the supporting
 code. This page documents both JSP-based and standalone reporting.
 v-gnikolov - 19/03/2018, V2 added Omniture support for DTL
 */

/* eslint-disable no-console */


var ERROR_MESSAGE = 'Omniture beacon elements are missing from page';
var instance = null,
    omniture = null,
    initialized = false;

var Omniture = /*#__PURE__*/function () {
  function Omniture() {
    (0, _classCallCheck2.default)(this, Omniture); //create singleton object

    if (!instance) {
      instance = this;
    }

    return instance;
  }
  /*
   Get page name based on the global window.SFLY_DTL object
   */


  (0, _createClass2.default)(Omniture, [{
    key: "getPageName",
    value: function getPageName() {
      if (typeof window === 'undefined') {
        return '';
      }

      return window.SFLY_DTL && window.SFLY_DTL.global ? window.SFLY_DTL.global.pageName : '';
    }
    /*
     Get brand name based on the body class name
     */

  }, {
    key: "getBrandName",
    value: function getBrandName() {
      if (typeof window === 'undefined') {
        return '';
      }

      if (window.SFLY_DTL && document.body && document.body.classList) {
        return document.body.classList.contains('brand-SFLY') ? 'shutterfly' : 'tinyprints';
      }
    }
    /*
     Get the user agent to see if is mobile or not
     */

  }, {
    key: "getUserAgent",
    value: function getUserAgent() {
      return navigator ? navigator.userAgent : '';
    }
    /*
     Get the user state helper function, only when the user is logged in
     */

  }, {
    key: "getUserState",
    value: function getUserState() {
      if (typeof window === 'undefined') {
        return '';
      }

      return window.SFLY_DTL ? window.SFLY_DTL.global.getUserState : '';
    } // check for adobe DTL or launch library loaded

  }, {
    key: "isOmnitureLoaded",
    value: function isOmnitureLoaded() {
      return typeof _satellite !== 'undefined';
    }
    /*
     Clear window.SFLY_DTL.page.pageDetails object
     */

  }, {
    key: "clearDtlPageDetails",
    value: function clearDtlPageDetails() {
      if (typeof window === 'undefined') {
        return;
      }

      if (window.SFLY_DTL && window.SFLY_DTL.page) {
        if (window.SFLY_DTL.page.pageDetails) {
          delete window.SFLY_DTL.page.pageDetails;
        }
      }
    }
    /*
     Clear window.SFLY_DTL.page.productDetails object
     */

  }, {
    key: "clearDtlProductDetails",
    value: function clearDtlProductDetails() {
      if (typeof window === 'undefined') {
        return;
      }

      if (window.SFLY_DTL && window.SFLY_DTL.page) {
        if (window.SFLY_DTL.page.productDetails) {
          delete window.SFLY_DTL.page.productDetails;
        }
      }
    }
    /*
     * Site feature is always enabled.  If not initialized yet, return undefined to drive initialization.
     */

  }, {
    key: "isDTLEnabled",
    value: function isDTLEnabled() {
      if (!initialized) {
        return undefined;
      }

      return true;
    } // Set up omniture DTL

  }, {
    key: "setupOmnitureTracking",
    value: function setupOmnitureTracking(appServerUrl, callback) {
      if (!initialized && typeof window !== 'undefined') {
        initialized = true;
        window.DTLSiteFeatureEnabled = true;
        var env = (0, _uigCurrentEnvironmentUtil.getCurrentEnv)();
        var cookieName = env === 'production' ? 'visitor' : 'visitor_'.concat(env);
        var visitorId = (0, _util.default)(cookieName);
        var isProduction = env === 'production';
        var selfHosted = true;
        var dtl = true;
        var satlibs = ['//assets.adobedtm.com/70ba143ce340e798f10817d5099963cd3fc433b4/satelliteLib-8a657c55d507da9632c802eddd309b2e644d154f-staging.js', '//assets.adobedtm.com/70ba143ce340e798f10817d5099963cd3fc433b4/satelliteLib-89e9de74a13f29cc7214f33ec997022a3101dd49-staging.js', '//adobe-dtm-vip01.shutterfly.com/sflyecommerce/stage/70ba143ce340e798f10817d5099963cd3fc433b4/satelliteLib-8a657c55d507da9632c802eddd309b2e644d154f-staging.js', '//adobe-dtm.staticsfly.com/stage/70ba143ce340e798f10817d5099963cd3fc433b4/satelliteLib-89e9de74a13f29cc7214f33ec997022a3101dd49-staging.js', '//assets.adobedtm.com/70ba143ce340e798f10817d5099963cd3fc433b4/satelliteLib-8a657c55d507da9632c802eddd309b2e644d154f.js', '//assets.adobedtm.com/70ba143ce340e798f10817d5099963cd3fc433b4/satelliteLib-89e9de74a13f29cc7214f33ec997022a3101dd49.js', '//adobe-dtm-vip01.shutterfly.com/sflyecommerce/70ba143ce340e798f10817d5099963cd3fc433b4/satelliteLib-8a657c55d507da9632c802eddd309b2e644d154f.js', '//adobe-dtm.staticsfly.com/prod/70ba143ce340e798f10817d5099963cd3fc433b4/satelliteLib-89e9de74a13f29cc7214f33ec997022a3101dd49.js'];
        window.SatelliteLibURL = satlibs[(isProduction ? 4 : 0) + (selfHosted ? 2 : 0) + (dtl ? 1 : 0)];
      }

      if (callback) {
        callback(true);
      }
    }
    /*
     * If data.event, this call is reporting an event.  If Launch is enabled, use Launch's _satellite.track to push the event.
     * Otherwise, just merge the data into SFLY_DTL and eventually the satellite library will see the change and report it.
     * We prefer the first option because events sometimes get lost for events like add to cart, where the page is about
     * to be reloaded.
     */

  }, {
    key: "putOmniture",
    value: function putOmniture(data, optionalTrackEvent) {
      if (typeof window === 'undefined') {
        return;
      }

      var host = window.location.origin;

      if (typeof window.SFLY_DTL === 'undefined') {
        window.SFLY_DTL = {};
      }

      if (typeof window.SFLY_DTL.updateCount === 'undefined') {
        window.SFLY_DTL.updateCount = 1;
      } else {
        window.SFLY_DTL.updateCount++;
      } // With adobe Launch we push the event.


      if (typeof window !== 'undefined' && typeof _satellite !== 'undefined' && data && data.event && data.event.eventInfo) {
        window.DTLSiteFeatureEnabled = true;
        window.$omnitureDTL.removeOmnitureJSPData(host, 'event');
        window.$omnitureDTL.putOmnitureJSPData(host, data);

        if (window.localStorage.getItem('enable_dtl_logging') === 'true') {
          console.log("call _satellite.track event='".concat((0, _stringify.default)(data.event), "' SFLY_DTL='").concat((0, _stringify.default)(window.SFLY_DTL), "'"));
        }

        window._satellite.track(data.event.eventInfo.eventName, window.SFLY_DTL);

        if (optionalTrackEvent) {
          if (window.localStorage.getItem('enable_dtl_logging') === 'true') {
            console.log("call _satellite.track optionalTrackEvent='".concat((0, _stringify.default)(optionalTrackEvent), "' SFLY_DTL='").concat((0, _stringify.default)(window.SFLY_DTL), "'"));
          }

          window._satellite.track(optionalTrackEvent, window.SFLY_DTL);
        }

        return;
      } // default case for old analytics where events just get merged into SFLY_DTL and we depend on satlib to see the change.


      if (!initialized) {
        this.setupOmnitureTracking(host, function () {
          //remove the event information because merged data stays in SFLY_DTL
          window.$omnitureDTL.removeOmnitureJSPData(host, 'event');
          window.$omnitureDTL.putOmnitureJSPData(host, data);
        });
        return;
      }

      window.$omnitureDTL.removeOmnitureJSPData(host, 'event');
      window.$omnitureDTL.putOmnitureJSPData(host, data);
    }
    /*
     Set the following values to be available on load of the CGD pages. Values in brackets should be populated
     dynamically for each page.
     Only populate the product values for the product sku viewed on load. siteExperience mobile,  desktop or tablet
     */

  }, {
    key: "trackDTLPageLoad",
    value: function trackDTLPageLoad(pageInfo, pageDetails, productDetails, projectDetails, delayedPageLoad) {
      var _this = this;

      var eventDetails = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var optionalTrackEvent = arguments.length > 6 ? arguments[6] : undefined;

      if (typeof window === 'undefined') {
        return;
      }

      var host = window.location.origin; //get session info and drop it into buffer, then get page-specific info and drop that too

      window.$omnitureDTL.loadOmnitureSession(host, function (session) {
        //tell bridge not to clobber existing populated values. Just a heads up in case that comes in handy someday
        session.noClobber = true; //remove the event information because merged data stays in SFLY_DTL

        window.$omnitureDTL.removeOmnitureJSPData(host, 'event');
        var dtlData = {
          page: {}
        };

        if (delayedPageLoad) {
          dtlData.delayedPageLoad = delayedPageLoad;
        }

        if (eventDetails) {
          dtlData.event = eventDetails.event;
        }

        if (pageInfo) {
          dtlData.page.pageInfo = pageInfo;
        }

        if (session) {
          dtlData.session = session.session;

          if (session.page && session.page.pageInfo && pageInfo) {
            dtlData.page.pageInfo.siteExperience = session.page.pageInfo.siteExperience;
          }
        }

        if (pageDetails) {
          dtlData.page.pageDetails = pageDetails;
        }

        if (productDetails) {
          dtlData.page.productDetails = productDetails;
        }

        if (projectDetails) {
          dtlData.page.projectDetails = projectDetails;
        }

        _this.putOmniture(dtlData, optionalTrackEvent);
      });
    }
    /*
     This is the main method of the module. From here you can send data to the omniture tracking system.
     What we need for this method is array of json objects. See the documentation to see the proper json schema.
     The second argument for the method is the linkName, which is going to be used in request adobe method
     s.t or s.tl. The last argument is for the type of the tracking 'tl' - if you want to track page
     link click or 't' - if you want to track page load events
     */

  }, {
    key: "trackPage",
    value: function trackPage(omnitureParams, linkName, typeTracking) {
      //if there is no 's' or 'scw' objects or proper array of json added, stop the logic underneath
      if (typeof window === 'undefined' || !omnitureParams || !this.isOmnitureLoaded()) {
        return;
      }

      var s = window.s,
          objectKeyInVars = [],
          objectKey = [],
          prop13Element = document.createElement('div');
      var prop13ElementContent = null,
          linkNameValue = null; //get all the keys from the object and all the keys that is needed to s.linkTrackVars

      omnitureParams.forEach(function (param) {
        if ((0, _keys.default)(param)[0] !== 'linkTrackVars' && (0, _keys.default)(param)[0] !== 'linkTrackEvents') {
          objectKeyInVars.push((0, _keys.default)(param)[0]);
        }

        objectKey.push((0, _keys.default)(param)[0]);
      }); //clear all the props and vars of window.s object that are passed to omnitureParams argument

      this.clearVars(objectKey); //assign the params to the global window.s object

      omnitureParams.forEach(function (param) {
        var getKey = (0, _keys.default)(param)[0]; //if it's a prop13 create shadow DOM elements, so we can pass the needed text to s.tl omniture funciton

        if (getKey === 'prop13') {
          prop13ElementContent = document.createTextNode(param[getKey]);
          prop13Element.appendChild(prop13ElementContent);
        }

        s[getKey] = param[getKey];
      }); //there is a relation between s.prop12, s.prop13, s.prop14

      if (objectKey.indexOf('prop13') !== -1) {
        s.prop12 = this.getPageName();
        s.prop14 = "".concat(s.prop12, "|").concat(s.prop13);
        objectKeyInVars.push('prop12', 'prop14');
      } //there is a relation between s.linkTrackEvents and s.events


      if (objectKey.indexOf('linkTrackEvents') !== -1) {
        s.events = s.linkTrackEvents;
        objectKeyInVars.push('events');
      }

      s.linkTrackVars = objectKeyInVars.join(); //populate the linkTrackVars variable

      linkNameValue = linkName ? linkName : s.prop14; //check if we are going to track something on link click or page load

      if (s && s.t && s.tl) {
        if (typeTracking === 'tl' || !typeTracking) {
          s.tl(prop13Element, 'o', linkNameValue);
        } else {
          s.t(true, 'o', linkNameValue);
        }
      }
    }
    /*
     This method will clear all the proprs and vars added to the array of objects.
     */

  }, {
    key: "clearVars",
    value: function clearVars(omnitureParams) {
      if (typeof window === 'undefined') {
        return;
      }

      var s = window.s;

      if (omnitureParams) {
        omnitureParams.push('linkTrackVars', 'prop1', 'prop12', 'prop14', 'eVar6', 'events');
        omnitureParams.forEach(function (param) {
          if ((0, _typeof2.default)(s[param]) !== undefined) {
            delete s[param];
          }
        });
      }
    }
  }]);
  return Omniture;
}();

var _default = omniture = new Omniture();

exports.default = _default;

if (typeof window !== 'undefined') {
  window.$omnitureDTL = {
    // Get session information that's reported to omniture.
    // returns a JS object containing:
    // session.visitorDetails.customerId
    // session.visitorDetails.visitorType
    // session.visitorDetails.visitorId
    // session.partner.id
    // session.partner.subId
    // page.pageInfo.storeType
    // page.pageInfo.siteExperience
    // page.pageInfo.siteSection
    // Gets session.partner.id, session.partner.subid, session.visitorDetails.customerId from getSessionUserInfo.
    // visitorType is determined by whether the customer is logged in or not.
    // visitorId is pulled from browser session.
    // page.pageInfo.storeType is shutterfly or tinyprints
    // page.pageInfo.siteExperience is d.web, m.web, or t.web and is determined by user device type (isMobile, isTable)
    // page.pageInfo.siteSection must be passed in, it's "store" or "photobooks" or something.
    // Removes all variables in list from the DTL layer
    // propertyList is a list of names for example [ "event", "session.partner" ]
    clearDTLVars: function clearDTLVars(propertyList) {
      if (typeof propertyList === 'undefined' || typeof window.SFLY_DTL === 'undefined') {
        window.SFLY_DTL = {};
        return;
      }

      function traceContext(context, searchObject) {
        var propertyName = context,
            delimiterPosition = context.indexOf('.');
        var tracedObject = searchObject;

        if (delimiterPosition > -1) {
          propertyName = context.slice(0, delimiterPosition);
        } //validate context


        if (searchObject.hasOwnProperty(propertyName) === false) {
          return tracedObject;
        }

        if (context.indexOf('.') > -1) {
          if ((0, _typeof2.default)(searchObject[propertyName]) === 'object') {
            tracedObject[propertyName] = traceContext(context.slice(delimiterPosition + 1, context.length), searchObject[propertyName]);
          }
        } else {
          delete searchObject[context];
        }

        return tracedObject;
      }

      if ((0, _isArray.default)(propertyList)) {
        propertyList.forEach(function (context) {
          traceContext(context, window.SFLY_DTL);
        });
        return;
      } //path will never be executed due to type requirement but that may change that


      if (typeof propertyList === 'string') {
        traceContext(propertyList, window.SFLY_DTL);
      }
    },
    // Recursively & destructively merge properties obj2 onto obj1
    _merge: function _merge(obj1, obj2) {
      if (typeof obj2 === 'undefined') {
        return obj1;
      }

      if (typeof obj1 === 'undefined') {
        return obj2;
      }

      for (var p in obj2) {
        // Property in destination object set; update its value.
        if (obj2[p] && obj2[p].constructor === Object) {
          if (typeof obj1[p] === 'undefined' || obj1[p].constructor !== Object) {
            obj1[p] = obj2[p];
          } else {
            obj1[p] = window.$omnitureDTL._merge(obj1[p], obj2[p]);
          }
        } else {
          obj1[p] = obj2[p];
        }
      }

      return obj1;
    },
    // Initialize omniture DTL.
    setupOmnitureDTLTracking: function setupOmnitureDTLTracking(appServerUrl, callback) {
      callback(true);
    },
    getCurrentUser: function getCurrentUser() {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var initAuth, _ref, jwtToken;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (window.$sflyAuth) {
                  _context.next = 9;
                  break;
                }

                _context.next = 4;
                return (0, _uigCdnLibraries.loadSflyAuth)();

              case 4:
                initAuth = _context.sent;
                _context.next = 7;
                return initAuth();

              case 7:
                _context.next = 11;
                break;

              case 9:
                if (!window.$sflyAuth.currentUser) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", window.$sflyAuth.currentUser.sfly_uid);

              case 11:
                _context.next = 13;
                return window.$sflyAuth.getIdToken();

              case 13:
                _ref = _context.sent;
                jwtToken = _ref.jwtToken;

                if (!jwtToken) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", window.$sflyAuth.currentUser.sfly_uid);

              case 17:
                _context.next = 21;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 19]]);
      }))();
    },
    loadOmnitureSession: function loadOmnitureSession(appServerUrl, onSuccess, onFailure) {
      if (typeof window.$omnitureDTL.sessionInfo === 'undefined') {
        window.$omnitureDTL.sessionInfo = {
          session: {
            visitorDetails: {
              visitorType: 'signedOut'
            }
          }
        };
        var partnerId = (0, _util.default)('visitor_partnerId') || 'SFLY';
        window.$omnitureDTL.sessionInfo.session = {
          partner: {
            id: partnerId,
            subId: 'WEB'
          },
          visitorDetails: {
            visitorType: 'signedOut'
          }
        };
        window.$omnitureDTL.sessionInfo.page = {
          pageInfo: {
            siteExperience: _uigDeviceUtil.default.tablet() ? 't.web' : _uigDeviceUtil.default.mobile() ? 'm.web' : 'd.web'
          }
        }; // Call getCurrentUser which is async because it may have to download sflyAuth code.

        (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          var userId, jwtData, options, orderCountResp, regionName;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return window.$omnitureDTL.getCurrentUser();

                case 2:
                  userId = _context2.sent;
                  window.$omnitureDTL.setVisitorInformation(userId);
                  _context2.prev = 4;
                  _context2.next = 7;
                  return window.$sflyAuth.getIdToken();

                case 7:
                  jwtData = _context2.sent;

                  if (!(jwtData.jwtToken && jwtData.payload && jwtData.payload.sfly_uid)) {
                    _context2.next = 14;
                    break;
                  }

                  options = {
                    headers: {
                      'content-type': 'application/json',
                      Authorization: "Bearer ".concat(jwtData.jwtToken),
                      'sfly-apikey': _Constants.CONFIG["".concat((0, _uigCurrentEnvironmentUtil.getCurrentEnv)())].apigeeApiKey
                    }
                  };
                  _context2.next = 12;
                  return _axios.default.get("".concat(_Constants.CONFIG["".concat((0, _uigCurrentEnvironmentUtil.getCurrentEnv)())].apigeeBaseUrl, "/user/userstat/").concat(jwtData.payload.sfly_uid, "/userOrderStat?queryBy=UID"), options);

                case 12:
                  orderCountResp = _context2.sent;
                  window.$omnitureDTL.sessionInfo.session.visitorDetails.orderCount = orderCountResp.data.custOrderTotal;

                case 14:
                  _context2.next = 19;
                  break;

                case 16:
                  _context2.prev = 16;
                  _context2.t0 = _context2["catch"](4);
                  console.log("Cannot find the user Details or order count ".concat(_context2.t0.error.message));

                case 19:
                  _context2.prev = 19;
                  _context2.next = 22;
                  return window.$omnitureDTL.getRegionName();

                case 22:
                  regionName = _context2.sent;

                  if (regionName !== '' && regionName != null) {
                    window.$omnitureDTL.sessionInfo.session.visitorDetails.regionName = regionName;
                  }

                  _context2.next = 29;
                  break;

                case 26:
                  _context2.prev = 26;
                  _context2.t1 = _context2["catch"](19);
                  console.error("Cannot Find RegionName based on IP ".concat(_context2.t1.ip));

                case 29:
                  onSuccess(window.$omnitureDTL.sessionInfo);

                case 30:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[4, 16], [19, 26]]);
        }))();
        return;
      }

      onSuccess(window.$omnitureDTL.sessionInfo);
    },
    setVisitorInformation: function setVisitorInformation(userId) {
      var prospectInfo = typeof window.$sflyAuth !== 'undefined' ? window.$sflyAuth.getProspectInformation() : null;
      var isGuest = window.$sflyAuth && window.$sflyAuth.currentUser && window.$sflyAuth.currentUser.user_type === 'GUEST';
      var visitorId = prospectInfo != null ? prospectInfo.visitorId : null; // remove the extra quote for the visitorId if it exists.

      if (visitorId != null && visitorId.length >= 2 && visitorId.charAt(0) === '"' && visitorId.charAt(visitorId.length - 1) === '"') {
        visitorId = visitorId.substr(1, visitorId.length - 2);
      }

      if (userId !== '' && userId != null) {
        window.$omnitureDTL.sessionInfo.session.visitorDetails.customerId = userId;
        window.$omnitureDTL.sessionInfo.session.visitorDetails.visitorType = isGuest ? 'guest' : 'signedIn';
        window.$omnitureDTL.sessionInfo.session.visitorDetails.visitorId = '';
      } else {
        window.$omnitureDTL.sessionInfo.session.visitorDetails.visitorType = prospectInfo && prospectInfo.isProspect ? 'prospect' : 'signedOut';
        window.$omnitureDTL.sessionInfo.session.visitorDetails.customerId = '';
        window.$omnitureDTL.sessionInfo.session.visitorDetails.visitorId = visitorId === null ? '' : visitorId;
      }

      if (window.SFLY_DTL && window.SFLY_DTL.session && window.SFLY_DTL.session.visitorDetails && window.SFLY_DTL.session.visitorDetails.visitorType !== window.$omnitureDTL.sessionInfo.session.visitorDetails.visitorType) {
        // if visitorType in the DTL changes (in particularly the one set by Bob)
        // lets update update Bob's user creds cache
        _axios.default.post('/bob/creds/sync', {
          delayedCustomerIDForDTLOnly: window.$omnitureDTL.sessionInfo.session.visitorDetails.customerId,
          visitorType: window.$omnitureDTL.sessionInfo.session.visitorDetails.visitorType
        });
      }
    },
    clone: function clone(obj) {
      var copy; // Handle the 3 simple types, and null or undefined

      if (obj == null || (0, _typeof2.default)(obj) !== 'object') {
        return obj;
      } // Handle Date


      if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
      } // Handle Array


      if (obj instanceof Array) {
        copy = [];

        for (var i = 0, len = obj.length; i < len; i++) {
          copy[i] = window.$omnitureDTL.clone(obj[i]);
        }

        return copy;
      } // Handle Object


      if (obj instanceof Object) {
        copy = {};

        for (var attr in obj) {
          if (obj.hasOwnProperty(attr)) {
            copy[attr] = window.$omnitureDTL.clone(obj[attr]);
          }
        }

        return copy;
      }

      throw new Error("Unable to copy obj! Its type isn't supported.");
    },
    getIpifyData: function getIpifyData() {
      return new _promise.default(function (resolve, reject) {
        _axios.default.get('https://api.ipify.org/?format=json', {
          timeout: 1000
        }).then(function (response) {
          if (response && response.status === 200) {
            resolve(response);
            return;
          }

          reject(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getParameterByName: function getParameterByName(name, url) {
      if (!url) {
        url = window.location.href;
      }

      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)")),
          results = regex.exec(url);

      if (!results) {
        return null;
      }

      if (!results[2]) {
        return '';
      }

      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    getPublicIpAddress: function getPublicIpAddress() {
      return new _promise.default(function (resolve, reject) {
        window.$omnitureDTL.getIpifyData().then(function (res) {
          if ((0, _uigCurrentEnvironmentUtil.getCurrentEnv)() !== 'production') {
            var spoofedIp = window.$omnitureDTL.getParameterByName('ipSpoof');

            if (spoofedIp !== '' && spoofedIp !== null) {
              resolve(spoofedIp);
              return;
            }
          }

          if (res.data.ip) {
            resolve(res.data.ip);
            return;
          }

          reject(res.data.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getGeoData: function getGeoData() {
      var apiUrl = (0, _uigCurrentEnvironmentUtil.getCurrentEnv)() === 'production' ? "https://api2.shutterfly.com/user/iplookup" : "https://api2.".concat((0, _uigCurrentEnvironmentUtil.getCurrentEnv)(), ".shutterfly.com/user/iplookup");
      return new _promise.default(function (resolve, reject) {
        window.$omnitureDTL.getPublicIpAddress().then(function (ipAddress) {
          var fetchUrl = "".concat(apiUrl, "?ip=").concat(ipAddress);
          var config = {
            headers: {
              'SFLY-Apikey': (0, _uigCurrentEnvironmentUtil.getCurrentEnv)() === 'production' ? 'uWrM911sdIvHivflYxyiHlGgmlgoaV0m' : 'djOlaaty605xAgYG2jOc9MwuwWtJ8NgG'
            }
          };

          _axios.default.get(fetchUrl, config).then(function (response) {
            if (response && response.status === 200) {
              resolve(response.data);
              return;
            }

            reject(response);
          }).catch(function (error) {
            reject(error);
          });
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getRegionName: function getRegionName() {
      return new _promise.default(function (resolve, reject) {
        window.$omnitureDTL.getGeoData().then(function (res) {
          if (res.regionName) {
            resolve(res.regionName);
            return;
          }

          reject(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // Call the callback.  Not needed anymore.
    processOmnitureJSPData: function processOmnitureJSPData(callback) {
      if (typeof callback === 'function') {
        callback();
      }
    },
    putDtlVar: function putDtlVar(propertyName, value, doNotClobber) {
      // places value inside of the namespace
      function makeContext(context, parentObject) {
        if (context !== '') {
          // context is not a root
          var objectName = context;
          var returnObject = parentObject;
          var delimiterPosition = context.indexOf('.');

          if (delimiterPosition > -1) {
            objectName = context.slice(0, delimiterPosition);
            parentObject[objectName] = {};
            returnObject = makeContext(context.slice(delimiterPosition + 1, context.length), parentObject[objectName]);
          } else {
            parentObject[objectName] = value;
          }
        } else {
          //context is point to root
          if ((0, _typeof2.default)(value) === 'object') {
            // if the value is an object than return this as the object
            parentObject = value;
          } else {
            console.error('putDtlVar: root object was specified as context but value was not an object.');
          }
        }

        return parentObject;
      }

      var newObject = makeContext(propertyName, {});

      if (doNotClobber) {
        window.SFLY_DTL = window.$omnitureDTL._merge(newObject, window.SFLY_DTL);
      } else {
        window.SFLY_DTL = window.$omnitureDTL._merge(window.SFLY_DTL, newObject);
      }
    },
    // Main entry point to merge data into SFLY_DTL
    putOmnitureJSPData: function putOmnitureJSPData(appServerUrl, jspData) {
      var context = '';
      var noClobber = false; // Do not merge together new event data with old event data

      if (typeof jspData.event !== 'undefined') {
        window.$omnitureDTL.clearDTLVars(['event']);
      }

      if (!!jspData.context) {
        context = jspData.context;
        delete jspData.context;
      }

      if (!!jspData.noClobber) {
        noClobber = jspData.noClobber;
        delete jspData.noClobber;
      }

      window.$omnitureDTL.putDtlVar(context, jspData, noClobber);

      if (window.localStorage.getItem('enable_dtl_logging') === 'true') {
        console.log((0, _stringify.default)(window.SFLY_DTL));
      }
    },
    removeOmnitureJSPData: function removeOmnitureJSPData(appServerUrl, jspData) {
      window.$omnitureDTL.clearDTLVars([jspData]);
    },
    // Send data into bridge
    fillDTLBuffer: function fillDTLBuffer(jspData) {
      window.$omnitureDTL.putOmnitureJSPData(jspData); // env is just for our internal use, Janay does not want it reported.

      delete window.SFLY_DTL.env;
    }
  };
}